import React from 'react';
import '../style/ToolsSection2.scss';

const categories = [
  {
    title: 'Design',
    tools: [
      '/tools/figma.svg',
      '/tools/Elementor.svg',
      '/tools/adobe-premiere.svg',
      '/tools/adobe-photoshop.svg',
      '/tools/adobe-after-effects.svg',
    ],
  },
  {
    title: 'Frontend',
    tools: [
      '/tools/html.svg',
      '/tools/css-3.svg',
      '/tools/javascript.svg',
      '/tools/react.svg',
      '/tools/tailwind.svg',
      '/tools/sass.svg',
    ],
  },
  {
    title: 'Backend',
    tools: [
      '/tools/python.svg',
      '/tools/java.svg',
      '/tools/sql.svg',
      '/tools/ruby.svg',
      '/tools/c++.svg',
      '/tools/kotlin.svg',
      '/tools/swift.svg',
    ],
  },
  {
    title: 'CMS',
    tools: [
      '/tools/wordpress.svg',
      '/tools/woocommerce.svg',
      '/tools/Elementor.svg',
    ],
  },
  {
    title: 'Social Media',
    tools: [
      '/tools/facebook.svg',
      '/tools/twitter.svg',
      '/tools/instagram.svg',
      
      
    ],
  },
];


const ToolsSection2 = () => {
  return (
    <section className="tools-section">
      <h2> Tools & Technologies</h2>
      <div className='category-section'>
      {categories.map((category, index) => (
        <div className="category" key={index}>
          <h3>{category.title}</h3>
          <div className="tools">
            {category.tools.map((tool, idx) => (
              <img key={idx} src={`${tool}`} alt={tool.split('.')[0]} />
            ))}
          </div>
          </div>

        
      ))}
      </div>
    </section>
  );
};

export default ToolsSection2;
